import { PermissionsService } from './../../../services/auth/permissions.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { clone } from '@helpers/arrays';
import { DatasetsService } from '@services/datasets/datasets.service';
import { MenuService } from '@services/menu/menu.service';
import { HIGHLIGHTS_TAB, ResultTabsService, ViewType } from '@services/results/result-tabs.service';
import { SimulationProgress, SimulationRunnerService } from '@services/simulation-set/simulation-runner.service';
import { ResultsStoreService } from '@services/results/results-store.service';
import { ApplicationStatus } from '@services/results/application-status';

@Component({
  selector: 'app-results-context-bar',
  templateUrl: './context-bar.component.html',
  styleUrls: ['./context-bar.component.scss'],
})
export class ContextBarComponent implements OnInit, AfterViewInit {
  public activeTab;
  public tabInfo = null;
  public summarySwitch;
  public progress: SimulationProgress;
  public preBuilding = false;

  get showSwitch() {
    return this.activeTab && this.activeTab !== HIGHLIGHTS_TAB;
  }

  get canEditAssumptions() {
    return this.permissions.getPermission('ModelDataLookuptables') === 'W';
  }

  constructor(
    public datasetsService: DatasetsService,
    private tabsService: ResultTabsService,
    private dsService: DatasetsService,
    private menu: MenuService,
    private changeRef: ChangeDetectorRef,
    private runner: SimulationRunnerService,
    private resultsStore: ResultsStoreService,
    private permissions: PermissionsService
  ) {}

  ngOnInit() {
    this.tabsService.activeView$.subscribe(view => {
      this.activeTab = view.tabName;
      this.tabInfo = view.Run_Date ? view.Run_Date : null;
      this.summarySwitch = view.type;
    });

    // SIMULATION PROGRESS
    this.runner.progress$.subscribe(progress => {
      this.progress = clone(progress);
      this.changeRef.detectChanges();
    });

    // APP STATUS
    this.resultsStore.appStatus$.subscribe((status: ApplicationStatus) => {
      // console.log(`🏁 Context - Status: ${status} (${ApplicationStatus[status]})`);

      if (status === ApplicationStatus.BuildingResults) {
        this.preBuilding = true;
      } else if (status === ApplicationStatus.DoneFetchingResults) {
        this.preBuilding = false;
      }
    });
  }

  ngAfterViewInit() {
    this.dsService.getRequiredDatasetImport();
    this.changeRef.detectChanges();
  }

  public changeView(type: ViewType) {
    this.tabsService.selectTab({ type });
  }

  public onEditAssumptionsClicked(e) {
    // isEditingAssumptions is set to false onDestroy of the view
    this.menu.isEditingAssumptions = true;
  }
}
